var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"up"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"up-img",attrs:{"src":require("img/indexImg/020.png")},on:{"click":_vm.webUp}})])}
var staticRenderFns = []

export { render, staticRenderFns }